import styled from "styled-components";
import {DefaultBox} from './lobby-wrapper.default.box';
import {styledByDevice} from "../../themes/architecture/styled-by-device";
import {LOBBY_PAGE} from '../../themes/css-global-classes';


const PCBox = styled(DefaultBox)`
   &:before {
    background-size: cover;
    top: 0;
    height: 35rem;
   }
`;

const MobileBox = styled(PCBox)`
  padding: 0;
  .${LOBBY_PAGE} & {
     &:before {
        display: block;
        opacity:1;
        top: 0;
      }
    }
`;

export const LobbyWrapperCasino777Box = styledByDevice(PCBox, MobileBox);